import React from 'react';
import List from 'antd/lib/list';
import Text from 'antd/lib/typography/Text';

interface ShortcutsProps {
    hasTracking?: boolean;
}

export default function Shortcuts(props: ShortcutsProps): JSX.Element {
    const { hasTracking = true } = props;
    const allItems = [
        { title: 'N', description: 'Repeat the last drawing' },
        { title: 'F', description: 'Go to the next frame' },
        { title: 'D', description: 'Go to the previous frame' },
        { title: 'V', description: 'Go forward 10 frames' },
        { title: 'C', description: 'Go backward 10 frames' },
        { title: 'O', description: 'Stop tracking class for next frames' },
    ];

    const items = hasTracking ? allItems : allItems.slice(0, -1);

    return (
        <div style={{ backgroundColor: '#fff' }}>
            <List bordered header={<Text strong>Shortcuts</Text>}>
                {items.map((item, index) => (
                    <List.Item key={index}>
                        <List.Item.Meta
                            avatar={<Text code>{item.title}</Text>}
                            description={item.description}
                        />
                    </List.Item>
                ))}
            </List>
        </div>
    );
}
